import styled from 'styled-components';

export const Divider = styled.div<{ $disabled?: boolean }>`
  height: 1px;
  width: 100%;
  background-color: ${(props) =>
    props.$disabled ? props.theme.colors.backgroundLight : props.theme.colors.backgroundAccent};
`;
